// flow

export const ESTIMATED_LEASING_FEES = 0;
export const ESTIMATED_LOSS_OF_RENT = 0;
export const ESTIMATED_VACANCY_CHARGES = 0;
export const ESTIMATED_EXIT_CAP = 0.04;
export const ESTIMATED_TRANSFER_TAX_AND_TRANSACTION_COSTS = 0.07;
